import React from "react";
import { Group, Badge } from "@mantine/core";
import {
  IconArrowDown,
  IconArrowsUpDown,
  IconCalendar,
} from "@tabler/icons-react";
import { NostrConnection } from "../../stores/NostrConnection";

interface ConnectionStatusBadgeProps {
  connection: NostrConnection;
}

const ConnectionStatusBadge: React.FC<ConnectionStatusBadgeProps> = ({
  connection,
}) => {
  const isReceiveOnly = connection.security_level_name === "receive_only";

  // Calculate expiration date badge
  let expirationDateBadge = null;
  if (
    connection.connection_expiration_days &&
    connection.connection_expiration_measured_from_date
  ) {
    const startDate = new Date(
      connection.connection_expiration_measured_from_date
    );
    const expirationDate = new Date(startDate);
    expirationDate.setDate(
      startDate.getDate() + connection.connection_expiration_days
    );

    expirationDateBadge = (
      <Badge
        size="lg"
        color="var(--mantine-color-gray-8)"
        leftSection={<IconCalendar size={14} />}
      >
        Expires {expirationDate.toLocaleDateString()}
      </Badge>
    );
  }

  return (
    <Group gap="xs">
      {isReceiveOnly ? (
        <Badge
          size="lg"
          leftSection={<IconArrowDown size={14} />}
          color="var(--mantine-color-gray-8)"
        >
          Receive Only
        </Badge>
      ) : (
        <Badge
          size="lg"
          color="var(--mantine-color-gray-8)"
          leftSection={<IconArrowsUpDown size={14} />}
        >
          Send & Receive
        </Badge>
      )}
      {expirationDateBadge}
    </Group>
  );
};

export default ConnectionStatusBadge;
